import risks from '../risks';
import { displayFinalizedTag, empSelectWidget, hideForms, showForms } from '../all';
import { openCloseWindow, windowTriggers } from '../../global/kendoWindows';
import { setupTextAreas } from '../../global/all';
import attachments from '../../global/attachments';
import attendees from '../attendees';
import { toggleApprovalLoading, toggleRejectLoading } from '../approvals';
import { showErrorNotification } from '../../global/notifications';

const SECTION_ID = 'MprExecutiveSummary';

const _projectId = $('[data-project-id]').data('project-id');
const _mprExecutiveSummaryId = $('#Id').val();

export default function() {
    let $mprExecutiveSummary = $('#mprExecSummaryForm');

    if ($mprExecutiveSummary.length) {
        pageInitialize()
            .finally(() => {
                $(document).trigger('on:PageUpdate');
                displayFinalizedTag();
            });
    }
}

const pageInitialize = function() {
    return new Promise((resolve) => {
        if (_mprExecutiveSummaryId > 0) {
            // Load Data on Initial Load
            showLoadingBar();
            reloadPage().then(() => {
                resolve();
            });
        } else {
            $('#mprExecSummaryForm').removeClass('hide-v');
            createMprExecutiveSummary();
            MprSelection();
            hideLoadingBar();
            resolve();
        }
    });
};

const removeDefaultDates = function() {
    $('input[data-role=datepicker]').each(function(index, item) {
        let $item = $(item),
            value = '';

        if ($item.data('kendoDatePicker')) {
            value = $item.data('kendoDatePicker').value();
            if (value !== null && value !== '' && value.getFullYear() <= 1901) {
                $item.data('kendoDatePicker').value('');
            }
        }
    });
};
const setDefaultEvent = () => {
    $('input[data-role=numerictextbox]').each(function(index, item) {
        let $item = $(item);
        if (item.id !== 'WarrantyDuration') {
            $item.focus(function() {
                //Remove annoying zero default value
                let $ele = $(this);
                if ($ele.val() === '0') $ele.data('kendoNumericTextBox').value('');
            }).focusout(function() {
                //restore zero if left unanswered
                let $ele = $(this);
                if ($ele.val().length === 0) $ele.data('kendoNumericTextBox').value(0);
            });
        }
    });
};
const attachCopyEvent = () => {
    let $copyIcon = $('.k-i-copy');
    if ($copyIcon.length) {
        $copyIcon.click(function() {
            let $comment = $(this).parents('.previousComment').find('[data-info="comment"]');
            if ($comment.length) {
                const el = document.createElement('textarea');
                el.value = $comment.text();
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
        });
    }
};

// Calculations
// ===============================================================================
const calculateDurations = function() {
    let $contractCompDate = $('#ContractCompleteDate'), $contractStartDate = $('#ContractStartDate'),
        $forecastCompDate = $('#ForecastCompDate'), $actualStartDate = $('#ActualStartDate');
    let contractEndDate,
        contractStartDate,
        diff,
        monthDiff,
        forecastComp,
        actualStartDate,
        todayJustDate,
        monthsElapsed,
        today = new Date(),
        dd = String(today.getDate()),
        mm = String(today.getMonth() + 1),
        yyyy = today.getFullYear(),
        percCompSched;
    todayJustDate = Date.parse(mm + '/' + dd + '/' + yyyy);

    if ($contractCompDate.val() !== '' && $contractStartDate.val() !== '') {
        contractEndDate = Date.parse($contractCompDate.val());
        contractStartDate = Date.parse($contractStartDate.val());
        diff = contractEndDate - contractStartDate;
        monthDiff = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;

        $('#prMprExecSum_contractDuration').text(monthDiff.toFixed(0) + ' month(s)');
        $('#ContractDuration').val(monthDiff.toFixed(0));
    }

    if ($forecastCompDate.val() !== '' && $actualStartDate.val() !== '') {
        //forecast duration
        forecastComp = Date.parse($forecastCompDate.val());
        actualStartDate = Date.parse($actualStartDate.val());
        diff = forecastComp - actualStartDate;
        monthDiff = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;
        $('#prMprExecSum_forecastDuration').text(monthDiff.toFixed(0) + ' month(s)');
        $('#ForecastDuration').val(monthDiff.toFixed(0));

        //perc comp (schedule)
        diff = todayJustDate - actualStartDate;
        monthsElapsed = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;
        percCompSched = (monthsElapsed / monthDiff) * 100.00;
        $('#prMprExecSum_percCompSchedule').text(percCompSched.toFixed(1) + ' %');
    }

    if ($forecastCompDate.val() !== '') {
        forecastComp = Date.parse($forecastCompDate.val());
        diff = forecastComp - todayJustDate;
        monthDiff = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;
        $('#prMprExecSum_monthsRemaining').text(monthDiff.toFixed(0) + ' month(s)');
    }
};
const calculateTotals = function() {
    let $cmst3 = $('#CM_ST_3'),/*1.2 Total (Pending Contract) Deprecated*/
        $pmst3 = $('#PM_ST_3'),/*1.2 Total (Pending Contract) Deprecated*/
        $cmst4 = $('#CM_ST_4'),/*9 Subtotal (Projected Costs*/
        $currentOverrideCosts = $('#OverrideAdjustmentCurrent'),/*9 Subtotal (Projected Costs*/
        $pmst4 = $('#PM_ST_4'),/*9 Subtotal (Projected Costs*/
        $previousOverrideCosts = $('#OverrideAdjustmentPrevious'),/*9 Subtotal (Projected Costs*/
        $cmst5 = $('#CM_ST_5'),/*2.2 Subtotal (Projected Costs) Deprecated*/
        $pmst5 = $('#PM_ST_5'),/*2.2 Subtotal (Projected Costs) Deprecated*/
        $cmst6 = $('#CM_ST_6'),/*3.0 -> Gross Profit Summary*/
        $pmst6 = $('#PM_ST_6'),/*3.0 -> Gross Profit Summary*/
        $gmpcmst = $('#GMP_CM_ST'),/*4.7 Potential GMP Profit Enhancments*/
        $gmppmst = $('#GMP_PM_ST'),/*4.7 Potential GMP Profit Enhancments*/
        $gpscmst = $('#GPS_CM_ST'),/*5.0 -> Gross ProfitSummary*/
        $gpspmst = $('#GPS_PM_ST'),/*5.0 -> Gross ProfitSummary*/
        $overrideRow = $('#OverrideRow'), $cm1 = $('#CM_1'), $pm1 = $('#PM_1'), $arcm1 = $('#TotalBilledCurrent'), nom,
        denom;

    $cmst3.text(kendo.toString((parseFloat($cm1.text().RemoveCharacters(',')) + parseFloat($('#CM_2').text().RemoveCharacters(','))), '##,#.00'));
    $pmst3.text(kendo.toString((parseFloat($pm1.text().RemoveCharacters(',')) + parseFloat($('#PM_2').text().RemoveCharacters(','))), '##,#.00'));

    $cmst5.text(kendo.toString((parseFloat($cmst4.text().RemoveCharacters(',')) + parseFloat($('#CM_13').text().RemoveCharacters(','))), '##,#.00'));
    $pmst5.text(kendo.toString((parseFloat($pmst4.text().RemoveCharacters(',')) + parseFloat($('#PM_13').text().RemoveCharacters(','))), '##,#.00'));
    if ($overrideRow.length || $('#ShowOverride').val() === 'True') {
        if ($currentOverrideCosts.length) {
            $currentOverrideCosts.text(kendo.toString((parseFloat($cmst4.text().RemoveCharacters(',')) - (parseFloat($('#CM_3').text().RemoveCharacters(',')) + parseFloat($('#CM_4')
                .text()
                .RemoveCharacters(',')) + parseFloat($('#CM_5').text().RemoveCharacters(',')) + parseFloat($('#CM_6').text().RemoveCharacters(',')) + parseFloat($('#CM_7')
                .text()
                .RemoveCharacters(',')) + parseFloat($('#CM_8').text().RemoveCharacters(',')) + parseFloat($('#CM_9').text().RemoveCharacters(',')) + parseFloat($('#CM_10')
                .text()
                .RemoveCharacters(',')) + parseFloat($('#CM_11').text().RemoveCharacters(',')) + parseFloat($('#CM_12').text().RemoveCharacters(',')))), '##,#.00'));
        }
        if ($previousOverrideCosts.length) {
            $previousOverrideCosts.text(kendo.toString((parseFloat($pmst4.text().RemoveCharacters(',')) - (parseFloat($('#PM_3').text().RemoveCharacters(',')) + parseFloat($('#PM_4')
                .text()
                .RemoveCharacters(',')) + parseFloat($('#PM_5').text().RemoveCharacters(',')) + parseFloat($('#PM_6').text().RemoveCharacters(',')) + parseFloat($('#PM_7')
                .text()
                .RemoveCharacters(',')) + parseFloat($('#PM_8').text().RemoveCharacters(',')) + parseFloat($('#PM_9').text().RemoveCharacters(',')) + parseFloat($('#PM_10')
                .text()
                .RemoveCharacters(',')) + parseFloat($('#PM_11').text().RemoveCharacters(',')) + parseFloat($('#PM_12').text().RemoveCharacters(',')))), '##,#.00'));
        }
        if ($currentOverrideCosts.text() === '0.00' && $previousOverrideCosts.text() === '0.00') {
            $overrideRow.remove();
        } else {
            $cmst4.parent().parent().removeClass('project-financial-summary__footer').addClass('project-financial-summary__body');
        }
    } else {
        $cmst4.text(kendo.toString(((parseFloat($('#CM_3').text().RemoveCharacters(',')) + parseFloat($('#CM_4').text().RemoveCharacters(',')) + parseFloat($('#CM_5')
            .text()
            .RemoveCharacters(',')) + parseFloat($('#CM_6').text().RemoveCharacters(',')) + parseFloat($('#CM_7').text().RemoveCharacters(',')) + parseFloat($('#CM_8')
            .text()
            .RemoveCharacters(',')) + parseFloat($('#CM_9').text().RemoveCharacters(',')) + parseFloat($('#CM_10').text().RemoveCharacters(',')) + parseFloat($('#CM_11')
            .text()
            .RemoveCharacters(',')) + parseFloat($('#CM_12').text().RemoveCharacters(',')))), '##,#.00'));
        $('#ProjectCostSubtotalCurrent').val(parseFloat($cmst4.text().RemoveCharacters(',')));
        $pmst4.text(kendo.toString(((parseFloat($('#PM_3').text().RemoveCharacters(',')) + parseFloat($('#PM_4').text().RemoveCharacters(',')) + parseFloat($('#PM_5')
            .text()
            .RemoveCharacters(',')) + parseFloat($('#PM_6').text().RemoveCharacters(',')) + parseFloat($('#PM_7').text().RemoveCharacters(',')) + parseFloat($('#PM_8')
            .text()
            .RemoveCharacters(',')) + parseFloat($('#PM_9').text().RemoveCharacters(',')) + parseFloat($('#PM_10').text().RemoveCharacters(',')) + parseFloat($('#PM_11')
            .text()
            .RemoveCharacters(',')) + parseFloat($('#PM_12').text().RemoveCharacters(',')))), '##,#.00'));
        $('#ProjectCostSubtotalPrevious').val(parseFloat($pmst4.text().RemoveCharacters(',')));
    }

    /*3.0 - Gross Profit Summary*/
    $cmst6.text(kendo.toString((parseFloat($cm1.text().RemoveCharacters(',')) - parseFloat($cmst4.text().RemoveCharacters(','))), '##,#.00'));
    $pmst6.text(kendo.toString((parseFloat($pm1.text().RemoveCharacters(',')) - parseFloat($pmst4.text().RemoveCharacters(','))), '##,#.00'));
    nom = parseFloat($cmst6.text().RemoveCharacters(','));
    denom = parseFloat($cm1.text().RemoveCharacters(','));
    $('#CM_ST_6perc').text(nom.GetPercentage(denom, 2));
    nom = parseFloat($pmst6.text().RemoveCharacters(','));
    denom = parseFloat($pm1.text().RemoveCharacters(','));
    $('#PM_ST_6perc').text(nom.GetPercentage(denom, 2));

    /*4.0 - GMP Profit Enhancements*/
    $gmpcmst.text(kendo.toString((parseFloat($('#FixedGeneralCurrent').val()) + parseFloat($('#LaborRateCurrent').val()) + parseFloat($('#InterCompanyCurrent')
        .val()) + parseFloat($('#OwnedEquipCurrent').val()) + parseFloat($('#Other1Current').val()) + parseFloat($('#Other2Current').val()) + parseFloat($('#Other3Current').val())), '##,#.00'));
    $gmppmst.text(kendo.toString((parseFloat($('#FixedGeneralPrevious').val()) + parseFloat($('#LaborRatePrevious').val()) + parseFloat($('#InterCompanyPrevious')
        .val()) + parseFloat($('#OwnedEquipPrevious').val()) + parseFloat($('#Other1Previous').val()) + parseFloat($('#Other2Previous').val()) + parseFloat($('#Other3Previous').val())), '##,#.00'));

    /*5.0 - GMP Gross Profit Summary*/
    $gpscmst.text(kendo.toString((parseFloat($cmst6.text().RemoveCharacters(',')) + parseFloat($gmpcmst.text().RemoveCharacters(','))), '##,#.00'));
    $gpspmst.text(kendo.toString((parseFloat($pmst6.text().RemoveCharacters(',')) + parseFloat($gmppmst.text().RemoveCharacters(','))), '##,#.00'));
    nom = parseFloat($gpscmst.text().RemoveCharacters(','));
    denom = parseFloat($cm1.text().RemoveCharacters(','));
    $('#GPS_CM_STperc').text(nom.GetPercentage(denom, 2));
    nom = parseFloat($gpspmst.text().RemoveCharacters(','));
    denom = parseFloat($pm1.text().RemoveCharacters(','));
    $('#GPS_PM_STperc').text(nom.GetPercentage(denom, 2));

    /*Accounts Receivable*/
    nom = parseFloat($arcm1.val());
    denom = parseFloat($cm1.text().RemoveCharacters(','));
    $('#AR_billedPerc').text(nom.GetPercentage(denom, 2));
    nom = parseFloat($('#RetainageWithheldCurrent').val());
    denom = parseFloat($arcm1.val());
    $('#AR_retPerc').text(nom.GetPercentage(denom, 2));

    /*Calculate PCO Totals*/
    let approvedTotal = 0, pcoaTotal = 0, pcobTotal = 0, $approvals = $('.approvedCurrent'), $pcoas = $('.pcoaCurrent'),
        $pcobs = $('.pcobCurrent');

    $approvals.each(function(index, ele) {
        approvedTotal += parseFloat(ele.attributes.value.value);
    });

    $pcoas.each(function(index, ele) {
        pcoaTotal += parseFloat(ele.attributes.value.value);
    });
    $pcobs.each(function(index, ele) {
        pcobTotal += parseFloat(ele.attributes.value.value);
    });

    let currentContract = $('#currentContract').text().RemoveCharacters(',');
    $('#approvedCurrentTotal').text(kendo.toString(approvedTotal, '##,#.00'));
    $('#pcoaCurrentTotal').text(kendo.toString(pcoaTotal, '##,#.00'));
    $('#pcobCurrentTotal').text(kendo.toString(pcobTotal, '##,#.00'));
    $('#pcoTotal').text(kendo.toString(pcoaTotal + pcobTotal, '##,#.00'));
    $('#totalContract').text(kendo.toString(parseFloat(currentContract) + pcoaTotal + pcobTotal, '##,#.00'));
};
const calculateVariance = function() {
    const $currentMonth = $('[id*=CM_]'), $previousMonth = $('[id*=PM_]'), $variance = $('[id*=V_]'),
        $gmpvst = $('#mprGMP_V_ST'), $gpsvst = $('#mprGPS_V_ST'), fields = $currentMonth.length;

    for (let i = 0; i < fields; i++) {
        const thisCurrent = $($currentMonth[i]),
            thisPrevious = $($previousMonth[i]),
            variance = parseFloat(thisCurrent.val() || thisCurrent.text().RemoveCharacters(',')) - parseFloat(thisPrevious.val() || thisPrevious.text().RemoveCharacters(','));
        if ($($variance[i]).text().indexOf('%') !== -1) {
            continue;/*to be calculated later*/
        }
        $($variance[i]).text(kendo.toString(variance, '##,#.00'));
    }
    $('#AR_V_1').text(kendo.toString($('#TotalBilledCurrent').val().RemoveCharacters(',') - $('#TotalBilledPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_2').text(kendo.toString($('#TotalReceivedCurrent').val().RemoveCharacters(',') - $('#TotalReceivedPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_3').text(kendo.toString($('#TotalAgingCurrent').val().RemoveCharacters(',') - $('#TotalAgingPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_4').text(kendo.toString($('#Under2MonthsCurrent').val().RemoveCharacters(',') - $('#Under2MonthsPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_5').text(kendo.toString($('#Under3MonthsCurrent').val().RemoveCharacters(',') - $('#Under3MonthsPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_6').text(kendo.toString($('#Over3MonthsCurrent').val().RemoveCharacters(',') - $('#Over3MonthsPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_7').text(kendo.toString($('#RetainageWithheldCurrent').val().RemoveCharacters(',') - $('#RetainageWithheldPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_8').text(kendo.toString($('#TargetRetainageCurrent').val().RemoveCharacters(',') - $('#TargetRetainagePrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_9').text(kendo.toString($('#NetCashCurrent').val().RemoveCharacters(',') - $('#NetCashPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_10').text(kendo.toString($('#TargetBillingCurrent').val().RemoveCharacters(',') - $('#TargetBillingPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_11').text(kendo.toString($('#OverUnderBillingCurrent').val().RemoveCharacters(',') - $('#OverUnderBillingPrevious').val().RemoveCharacters(','), '##,#.00'));
    $('#AR_V_12').text(kendo.toString($('#UnapprovedInvoicesCurrent').val().RemoveCharacters(',') - $('#UnapprovedInvoicesPrevious').val().RemoveCharacters(','), '##,#.00'));

    /*Calculate GMP Variance*/
    $('#mprGMP_V_1').text(kendo.toString($('#FixedGeneralCurrent').val() - $('#FixedGeneralPrevious').val(), '##,#.00'));
    $('#mprGMP_V_2').text(kendo.toString($('#LaborRateCurrent').val() - $('#LaborRatePrevious').val(), '##,#.00'));
    $('#mprGMP_V_3').text(kendo.toString($('#InterCompanyCurrent').val() - $('#InterCompanyPrevious').val(), '##,#.00'));
    $('#mprGMP_V_4').text(kendo.toString($('#OwnedEquipCurrent').val() - $('#OwnedEquipPrevious').val(), '##,#.00'));
    $('#mprGMP_V_5').text(kendo.toString($('#Other1Current').val() - $('#Other1Previous').val(), '##,#.00'));
    $('#mprGMP_V_6').text(kendo.toString($('#Other2Current').val() - $('#Other2Previous').val(), '##,#.00'));
    $('#mprGMP_V_7').text(kendo.toString($('#Other3Current').val() - $('#Other3Previous').val(), '##,#.00'));
    $gmpvst.text(kendo.toString($('#GMP_CM_ST').text().RemoveCharacters(',') - $('#GMP_PM_ST').text().RemoveCharacters(','), '##,#.00'));
    /*Calculate GPS Variance and Percent*/
    $gpsvst.text(kendo.toString($('#GPS_CM_ST').text().RemoveCharacters(',') - $('#GPS_PM_ST').text().RemoveCharacters(','), '##,#.00'));

    //Calculate Percents
    let denom;
    // if (denom !== 0) $('#mprV_ST_6perc').text((100 * vstVal / denom).toFixed(2) + '%'); else $('#mprV_ST_6perc').text('0.0%');
    $('#mprV_ST_6perc').text(($('#CM_ST_6perc').text().RemoveCharacters('%') - $('#PM_ST_6perc').text().RemoveCharacters('%')).toFixed(2) + '%');
    denom = parseFloat($('#CM_ST_6').text().RemoveCharacters(',')) + parseFloat($gmpvst.text().RemoveCharacters(','));
    if (denom !== 0) $('#mprGPS_V_STperc').text((100 * parseFloat($gpsvst.text().RemoveCharacters(',')) / denom).toFixed(2) + '%'); else $('#mprGPS_V_STperc').text('0.0%');
};

function calculateErGpRemaining() {
    let $erFinish = $('input[id*=ErToFinish]');
    let $gpFinish = $('input[id*=GpToFinish]');
    let totalRev = parseFloat($erFinish.val()).toFixed(2);
    let runningTotal = Number(parseFloat($('[id*=Er1]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Er2]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Er3]').val() || 0)
        .toFixed(2)) + Number(parseFloat($('[id*=Er4]').val() || 0).toFixed(2));
    let remaining = totalRev - runningTotal;
    $('[id*=ErRemaining]').text(kendo.toString(remaining, '##,#.00'));

    let totalGp = parseFloat($gpFinish.val()).toFixed(2);
    runningTotal = Number(parseFloat($('[id*=Gp1]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Gp2]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Gp3]').val() || 0)
        .toFixed(2)) + Number(parseFloat($('[id*=Gp4]').val() || 0).toFixed(2));
    remaining = totalGp - runningTotal;
    $('[id*=GpRemaining]').text(kendo.toString(remaining, '##,#.00'));
}

//Validation

const checkYes = (radioGroup) => {
    let isYes = false;
    radioGroup.each((i, radio) => {
        const that = $(radio);
        if (!that.prop('checked')) return;
        isYes = that.val() === '1';
    });
    return isYes;
};

//Event Functions
const MprSelection = function() {
    let $mprSelection = $('#mprExecSumExistingList');

    if ($mprSelection.length) {
        $mprSelection.change(function() {
            let mid = parseInt(this.value);
            window.location.replace(`/Forms/ProjectReview/MprExecutiveSummary/${_projectId}/${mid}`);
        });
    }
};

const createMprExecutiveSummary = function() {
    let $createMprBtn = $('#mprExecSummaryCreateNewBtn');
    if ($createMprBtn.length) {
        $createMprBtn.click(function() {
            showLoadingBar();
            hideForms();
            let pid = {
                pid: _projectId,
                month: new Date($('#mprExecSumExistingList').data('kendoDropDownList').text().split(' - ')[0].replace(' ', ' 1 ')).toLocaleDateString().replace('/1/', '/'),
            };

            $.post('/Forms/ProjectReview/CreateMprExecSummaryHeader', pid, function(response) {
                let info = response.split(':'), mid = parseInt(info[0]);
                window.location.replace(`/Forms/ProjectReview/MprExecutiveSummary/${_projectId}/${mid}`);
            });
        });
    }
};
const updateExecSummaryProjectSchedule = function() {
    let $datePickers = $('input[data-role=datepicker]');
    if ($datePickers.length) {
        $datePickers.change(function() {
            calculateDurations();
        });
    }
};
const updateErGpRemaining = function() {
    let $erGp = $('input[id^=Er], input[id^=Gp]');
    if ($erGp.length) {
        $erGp.blur(function() {
            calculateErGpRemaining();
        });
    }
};
const setNumericMax = function() {
    let $erGp = $('input[id^=Er].form-control, input[id^=Gp].form-control');
    if ($erGp.length) {
        $erGp.focus(function() {
            if (this.id !== 'ErToFinish' && this.id !== 'GpToFinish') {
                let section = this.id.substr(0, 2);
                let amountRemaining = parseFloat($('#' + section + 'Remaining').text().RemoveCharacters(',')),
                    k_ele = $(this).data('kendoNumericTextBox'), currentValue = k_ele.value();
                k_ele.max(currentValue + amountRemaining);
            }
        });
    }
};

const toggleExplanation = function() {
    let $explanationItems = $('#explanationItems');
    if ($explanationItems.length) {
        $explanationItems.change(function() {
            let $items = $('#explanationItems input:checked'), $explanation = $('#checklistExplanationForm'),
                showExplanation = false;

            $items.each(function(index, ele) {
                showExplanation = $(ele).val() === '1';
                return !showExplanation;
            });

            if (showExplanation) {
                $explanation.show();
                return;
            }

            $explanation.hide();
            $explanation.find('textarea').val('').keyup();
        });
    }
};
const saveData = function(approval) {
    return new Promise((resolve, reject) => {
        let $form = $('#mprExecSummaryForm'),
            $disabledItems = $form.find(':disabled');

        if ($disabledItems.length < 10) {
            if (!doFormValidation()) return;

            let url = '/Forms/ProjectReview/SaveExecSummaryAnswers?pid=' + _projectId;
            if (approval) {
                url += '&approval=true';
            }
            let formData = $form.serializeArray();

            $.post(url, formData, function(response) {
                if (response === -1) {
                    kendo._l.showErrorNotification('Invalid Data unable to update data');
                    reject();
                } else if (response > 0) {
                    kendo._l.showSuccessNotification();
                    resolve();
                } else {
                    kendo._l.showInfoNotification('Form has already been approved and cannot be updated');
                    reject();
                    reloadPage()
                        .finally(() => {
                            $(document).trigger('on:PageUpdate');
                        });
                }
            });
        }
    });
};

const attachSaveEvent = () => {
    let $saveBtn = $('.form-footer__content .k-button.k-red');

    if ($saveBtn.length) {
        $saveBtn.click(function() {
            if (event != null) event.preventDefault();
            saveData();
        });
    }
};
const doFormValidation = function() {
    let checklist = $('input[type="radio"]'), checklistValidated = true;
    $('.k-invalid').removeClass('k-invalid');
    $('.form-item__validation.--danger').removeClass('.form-item__validation').removeClass('.--danger');

    /*Checkbox Validation*/
    checklist.each(function(index, ele) {
        let name = ele.name;
        let checklistSection = $('input[name=' + name + ']');
        if (!checklistSection.is(':checked')) {
            checklistValidated = false;
            checklistSection.parent().parent().addClass('form-item__validation --danger');
        }
    });

    /*WarrantyDuration Validation*/
    let $warrantyDuration = $('#WarrantyDuration'), warrantyValidation = $.isNumeric($warrantyDuration.val());
    if (!warrantyValidation) {
        $warrantyDuration.parent().addClass('k-invalid');
    }

    /*PmUnderBilled Validation*/
    let $pmUnderBilled = $('#PmUnderbilled'),
        pmUnderBilledValidation = $pmUnderBilled.val() !== '';
    if (!pmUnderBilledValidation) {
        $pmUnderBilled.addClass('k-invalid');
    }
    /*PmUpsidesDownsides Validation*/
    let $pmUpsidesDownsides = $('#PmUpsidesDownsides'),
        pmUpsidesDownsides = $pmUpsidesDownsides.val() !== '';
    if (!pmUpsidesDownsides) {
        $pmUpsidesDownsides.addClass('k-invalid');
    }
    /*PmProjectStatus Validation*/
    let $pmProjectStatus = $('#PmProjectStatus'), pmProjectStatus = $pmProjectStatus.val() !== '';
    if (!pmProjectStatus) {
        $pmProjectStatus.addClass('k-invalid');
    }

    /* Additional Explanation Validation */
    let explanationValidation = true;
    const damagesRadios = $('[name="OpsLiquidDamages"]');
    const complianceRadios = $('[name="OpsNonCompliance"]');
    const backChargeRadios = $('[name="OpsBackCharges"]');
    const incentiveRadios = $('[name="OpsAdditionalCost"]');
    const $checklistExplanation = $('#ChecklistExplanation');
    const commentRequired = checkYes(damagesRadios) || checkYes(complianceRadios) || checkYes(backChargeRadios) || checkYes(incentiveRadios);
    if (commentRequired) {
        const comment = ($checklistExplanation.val() || $checklistExplanation.text()).trim();
        explanationValidation = comment.length > 0;
    }
    if (!explanationValidation) $checklistExplanation.addClass('k-invalid');

    if (!(checklistValidated && warrantyValidation && pmUnderBilledValidation && pmUpsidesDownsides && pmProjectStatus && explanationValidation)) {
        kendo._l.showErrorNotification('Some required fields are not completed. Please complete the fields and try submitting the form again');
        return false;
    }
    return true;
};
const attachApprovalEvents = function() {
    let $approvalButtons = $('[id^=mprExecSumApprovalBtn]'),
        $rejectApprovalBtn = $('#removeApprovals, #removeApprovalsUnlock');

    if ($approvalButtons.length) {
        $approvalButtons.unbind('click');
        $approvalButtons.bind('click', function() {
            if (event != null) event.preventDefault();
            let id = this.id, role = id.split('_')[1];
            if (!doFormValidation()) return;
            saveApproval(role)
                .then(function() {
                    if ($('#Finalized').val() === 'False') {
                        saveData(true)
                            .then(() => {
                                reloadPage()
                                    .finally(() => {
                                        $(document).trigger('on:PageUpdate');
                                    });
                            });
                    } else {
                        reloadPage()
                            .finally(() => {
                                $(document).trigger('on:PageUpdate');
                            });
                    }
                })
                .catch((response) => {
                    //Approval Failed for some reason
                    console.error(response);
                });
        });
    }

    if ($rejectApprovalBtn.length) {
        $rejectApprovalBtn.unbind('click');
        $rejectApprovalBtn.bind('click', function() {
            let unlock = this.id === 'removeApprovalsUnlock';
            rejectApprovals({ unlockForm: unlock }).then(function() {
                //Rejection Completed
                reloadPage()
                    .finally(() => {
                        $(document).trigger('on:PageUpdate');
                    });
            })
                .catch((response) => {
                    //Rejection Failed for some reason
                    console.error(response);
                });
        });
    }
};
const hideLoadingBar = function() {
    $('.k-widget.k-dropdown.form-control').show();
    $('#loading').addClass('hide-v');
};
const showLoadingBar = function() {
    $('.k-widget.k-dropdown.form-control').hide();
    $('#loading').removeClass('hide-v');
};
const reloadPage = function() {
    return new Promise((resolve, reject) => {
        let data = {
            pid: _projectId, mid: _mprExecutiveSummaryId, section: 'mprExecSum',
        };

        //Reload Answers
        $('#mprExecSumAnswers').load(`/Forms/ProjectReview/MprExecutiveSummaryAnswers/${_projectId}/${_mprExecutiveSummaryId}`, function(response, textStatus, req) {
            if (req.status === 500) {
                showErrorNotification('Timeout Error: Failed to get data');
                reject();
                return;
            }

            /*Setting up Elements*/
            $('#prMprExecSumCurrentlyViewingDiv').html($('#projectModel_CreatedBy').val()).show();
            //Reload Risks
            risks();
            //Reload Approvals
            loadApprovals()
                .then(() => {
                    attachApprovalEvents();
                });
            //Reload Attachments
            data.section = SECTION_ID;
            $('#attachmentContainer').load('/Forms/ProjectReview/ReloadAttachments', data, function() {
                attachments();
                // load Attendees after Attachments are loaded
                attendees();
            });
            showForms();
            hideLoadingBar();
            $('#mprExecSumCreateNewBtn').parent().hide();
            SetupPage();
            resolve();
        });
    });
};

const loadApprovals = function() {
    return new Promise((resolve) => {
        $('[data-section="approvals"]').load(`/Forms/MprExecutiveSummary/Approvals/${_projectId}/${_mprExecutiveSummaryId}`, () => {
            attachApprovalEvents();
            empSelectWidget();
            $(document).trigger('on:PageUpdate');
            resolve();
        });
    });
};

const saveApproval = function(role) {
    event != null && event.preventDefault();

    return new Promise((resolve, reject) => {
        if (Number($('#CM_1').text()) === 0) {
            showErrorNotification('Invalid Data unable to update data');
            reject('Invalid Data unable to update data');
            return;
        }

        // showApprovalLoadingBar(role);
        toggleApprovalLoading(role);
        let $userInput = $('#prMprExecSumApprovalEmp_' + role), $pinInput = $('#prMprExecSumApprovalPin_' + role),
            data = {
                pid: _projectId,
                mid: _mprExecutiveSummaryId || -1,
                empNum: parseInt($userInput.val() || 0),
                pin: $pinInput.val() || 'invalid',
                role: role,
            };

        $pinInput.removeClass('is-invalid');
        $userInput.removeClass('is-invalid');

        $.post('/Forms/ProjectReview/SubmitApproval', data, function(response) {
            toggleApprovalLoading(role);
            if (response === 'Incorrect PIN') {
                showErrorNotification('Incorrect/Invalid Pin Provided');
                $pinInput.addClass('is-invalid');
                reject('Incorrect/Invalid Pin Provided');
            } else if (response === 'Not Permitted') {
                showErrorNotification('Selected team member does not have approval permission.');
                $userInput.addClass('is-invalid');
                reject('Selected team member does not have approval permission.');
            } else if (response === 'User has already approved form') {
                showErrorNotification('User has already approved form');
                reject('User has already approved form');
            } else {
                resolve();
            }
        })
            .fail(function() {
                showErrorNotification('Failed to submit approval. Please ensure your pin is set');
                toggleApprovalLoading(role);

                reject('Failed to submit approval. Please ensure your pin is set');
            });
    });
};

const rejectApprovals = function(data) {
    toggleRejectLoading();
    data.pid = _projectId;
    data.mid = _mprExecutiveSummaryId || -1;
    return new Promise((resolve, reject) => {
        let rejectUrl = '/Forms/ProjectReview/RemoveMprExecSumApprovals';

        $.post(rejectUrl, data, function(response) {
            $('#approvalRemovalPopup').data('kendoWindow').close();
            if (response === 'Failed') {
                showErrorNotification('Failed to Reject/Reset Approvals');
                toggleRejectLoading();
                reject('Failed to Reject/Reset Approvals');
            } else {
                resolve();
            }
        }).fail(function() {
            toggleRejectLoading();
            showErrorNotification('Failed to Reject/Reset Approvals');
            reject('Failed to Reject/Reset Approvals');
        });
    });
};

const SetupPage = function() {
    //Clear Initial Values
    removeDefaultDates();
    setDefaultEvent();
    attachCopyEvent();

    //Run Calculations
    calculateDurations();
    calculateErGpRemaining();
    calculateTotals();
    calculateVariance();

    //SetupEvents
    MprSelection();
    createMprExecutiveSummary();
    updateExecSummaryProjectSchedule();
    updateErGpRemaining();
    setNumericMax();
    toggleExplanation();
    attachSaveEvent();

    //General Setup
    windowTriggers();
    openCloseWindow();
    setupTextAreas();
    // $(document).trigger('on:PageUpdate');
};
